/** Bloc contacts : plusieurs fiches, « Ajouter aux factures ». */
import { Button } from "../../components/Button";
import { CheckField } from "../../components/CheckField";
import { Field } from "../../components/Field";
import { emptyContact, type ClientDraft } from "./types";

type ContactsSectionProps = {
  draft: ClientDraft;
  setDraft: (next: ClientDraft) => void;
};

export function ContactsSection({ draft, setDraft }: ContactsSectionProps) {
  function patch(i: number, key: keyof ReturnType<typeof emptyContact>, value: string | boolean) {
    const contacts = draft.contacts.map((c, idx) => (idx === i ? { ...c, [key]: value } : c));
    setDraft({ ...draft, contacts });
  }

  return (
    <section className="grid gap-3">
      <div className="flex items-center justify-between">
        <h2 className="m-0 font-[Nunito] text-lg text-indigo-950">Informations de contact</h2>
        <Button variant="ghost" onClick={() => setDraft({ ...draft, contacts: [...draft.contacts, emptyContact()] })}>
          Ajouter un contact
        </Button>
      </div>
      {draft.contacts.length === 0 ? <p className="m-0 text-sm text-slate-500">Aucun contact.</p> : null}
      {draft.contacts.map((c, i) => (
        <div key={i} className="grid grid-cols-2 gap-3 rounded-xl bg-indigo-50/60 p-3 max-[640px]:grid-cols-1">
          <Field label="Prénom" value={c.first_name} onChange={(e) => patch(i, "first_name", e.target.value)} />
          <Field label="Nom" value={c.last_name} onChange={(e) => patch(i, "last_name", e.target.value)} />
          <Field label="E-mail" type="email" value={c.email} onChange={(e) => patch(i, "email", e.target.value)} />
          <Field label="Téléphone" value={c.phone} onChange={(e) => patch(i, "phone", e.target.value)} />
          <CheckField label="Ajouter aux factures" checked={c.add_to_invoices} onChange={(v) => patch(i, "add_to_invoices", v)} />
          <div>
            <Button variant="ghost" onClick={() => setDraft({ ...draft, contacts: draft.contacts.filter((_, j) => j !== i) })}>
              Retirer
            </Button>
          </div>
        </div>
      ))}
    </section>
  );
}
